import { useTheme } from "@emotion/react";
import { Stack, Typography } from "@mui/material"
import CenteredText from "components/CenteredText"
import Page from "components/Page"
import PepperKissing from "assets/images/pepper_kissing.png"
import { functions } from 'lib/firebase'
import { useEffect } from "react";

import { fireAuth } from 'lib/firebase';
import { useRecoilValue } from "recoil";
import { instanceIdAtom } from "lib/globalState";
import { useHistory } from "react-router";

const Fine = () => {
    const theme = useTheme();
    const instanceId = useRecoilValue(instanceIdAtom)
    const history = useHistory();

    const expireToken = () => {
        try {
            const expireTokenF = functions.httpsCallable('areax_expireToken');
            expireTokenF({ instanceId })
                .then((result) => {
                    const { success, error } = result.data;
                    if (success) {
                        console.log('token expire ok')
                        fireAuth.signOut()
                    } else {
                        console.log(error)
                    }
                })
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setTimeout(() => {
            expireToken()
            history.push('/wall_loghi_fine')
        }, 5000)
    }, [])

    return (<Page
        bg={theme.palette.background.paper}
        syncNavCommand="CIAO_STATO_PIACER">
        <div style={{
            display: 'flex',
            flex: 1,
            backgroundPositionX: 'center',
            backgroundPositionY: '10vh',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url(${PepperKissing})`,
        }}>
            <div style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column-reverse',
                background: 'linear-gradient(0deg, rgb(0, 58, 92) 0%, rgb(0, 66, 105) 50%, rgba(0, 0, 0, 0) 85%)'
            }}>
                <Stack spacing={1} sx={{
                    display: 'flex',
                    flex: 0.6
                }}>
                    <CenteredText>
                        <Typography variant="h2">Alla prossima!</Typography>
                        <Typography variant="h5" sx={{ paddingInline: '1.1rem', lineHeight: '2rem' }}>
                            è stato un piacere interagire
                            con te.
                        </Typography>
                    </CenteredText>
                </Stack>
            </div>
        </div>
    </Page>)
}
export default Fine